import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES } from '../../../routes';
import { CadastroBasicoCNPJForm } from '../components/CadastroBasicoCNPJForm';
import { getUnidadePenitenciaria, cadastrarUnidadePenitenciaria, alterarUnidadePenitenciaria, excluirUnidadePenitenciaria, } from './unidades_penitenciarias.service';
export var UnidadesPenitenciariasAlterar = function () {
    return (_jsx(CadastroBasicoCNPJForm, { pagina: PAGINAS.UNIDADES_PENITENCIARIAS, rota: ROUTES.UNIDADES_PENITENCIARIAS, services: {
            getItem: getUnidadePenitenciaria,
            cadastrarItem: cadastrarUnidadePenitenciaria,
            alterarItem: alterarUnidadePenitenciaria,
            excluirItem: excluirUnidadePenitenciaria,
        } }));
};
export default UnidadesPenitenciariasAlterar;
